import { useSupabaseClient } from '#imports'

export const useContactForm = () => {
  const supabase = useSupabaseClient()
  const isSubmitting = ref(false)
  const error = ref<string | null>(null)
  const success = ref(false)

  const submitForm = async (formData: {
    name: string
    email: string
    subject: string
    message: string
    userId: string | null
  }) => {
    isSubmitting.value = true
    error.value = null
    success.value = false

    try {
      const { error: submitError } = await supabase
        .from('contact_messages')
        .insert([
          {
            name: formData.name,
            email: formData.email,
            subject: formData.subject,
            message: formData.message,
            user_id: formData.userId,
            created_at: new Date().toISOString()
          }
        ])

      if (submitError) throw submitError

      success.value = true
      return true
    } catch (e: any) {
      error.value = e.message || 'Nepodařilo se odeslat zprávu'
      return false
    } finally {
      isSubmitting.value = false
    }
  }

  return {
    submitForm,
    isSubmitting,
    error,
    success
  }
}
